import MuiLink from "@mui/material/Link";
import {Link} from "react-router-dom";
import {cx} from "@emotion/css";

import {designColors} from "~/ui";

import {ILink} from "../ILink";
import {styles} from "./PrimaryRouterLink.styles";

interface RouterLinkProps extends ILink {
  to: string;
}

export const BmPrimaryRouterLink: React.FC<RouterLinkProps> = ({
  to,
  underline = "always",
  weight = "regular",
  className,
  sx,
  color = designColors.primary,
  target,
  disabled,
  onClick,
  children,
  ...restProps
}) => {
  return (
    <MuiLink
      {...restProps}
      className={cx(styles.link(color), styles.weight(weight), disabled && styles.disabled, className)}
      sx={sx}
      component={disabled ? "span" : Link}
      {...(disabled ? {} : {to})}
      underline={disabled ? "none" : underline}
      target={target}
      aria-disabled={disabled || undefined}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        onClick?.(e);
      }}
    >
      {children}
    </MuiLink>
  );
};
